import React from 'react'

import { Autocomplete, FormControl, TextField } from '@mui/material'
import { Tenant } from '../types'

interface Props {
  label?: string
  value: Tenant | null
  options: Tenant[]
  onChange: (val: Tenant | null) => void
  disabled?: boolean
  variant?: 'outlined' | 'filled' | 'standard'
}

const TenantPicker: React.FC<Props> = ({ label, value, options, onChange, disabled = false, variant = 'outlined' }) => {
  const handleChange = (_: React.SyntheticEvent, value: Tenant | null) => {
    onChange(value)
  }

  return (
    <FormControl
      variant={variant}
      fullWidth
      sx={{
        '&.MuiFormControl-root': { minWidth: 160 },
      }}
    >
      <Autocomplete
        value={value}
        options={options}
        onChange={handleChange}
        getOptionLabel={(option: Tenant) => option.name}
        disabled={disabled}
        includeInputInList
        isOptionEqualToValue={(option, value) => value.referenceId === option.referenceId}
        clearIcon={null}
        renderInput={(params) => (
          <TextField
            {...params}
            margin={variant === 'outlined' ? 'normal' : 'dense'}
            variant={variant}
            label={label}
            sx={{ margin: 0 }}
          />
        )}
      />
    </FormControl>
  )
}

export default TenantPicker
